var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 4.00293C3.67894 4.00293 2 5.68187 2 7.75293V16.2461C2 18.3172 3.67894 19.9961 5.75 19.9961H18.2422C20.313 19.9961 21.992 18.317 21.9922 16.2461L21.9961 7.75293C21.9961 5.68186 20.3171 4.00293 18.2461 4.00293H5.75ZM3.5 7.75293C3.5 6.51029 4.50736 5.50293 5.75 5.50293H18.2461C19.4887 5.50293 20.4961 6.5103 20.4961 7.75293V9.00005H3.5V7.75293ZM5.75 18.4961C4.50736 18.4961 3.5 17.4888 3.5 16.2461V10.5H20.4956L20.4922 16.2461C20.4922 17.4888 19.4848 18.4961 18.2422 18.4961H5.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard1);
export default __webpack_public_path__ + "static/media/credit-card-1.cb3ac36a47f83b64bb12e8b9b08f8806.svg";
export { ForwardRef as ReactComponent };